import classNames from "classnames";
import {ImageProps} from "next/image";

import {Media} from "../graphql/types";

export interface MediaImageProps {
  media: Partial<Media>;
  className?: string | null;
  imageProps?: Partial<ImageProps>;
}

/**
 * Media image (attached to a Searchable model)
 */
export default function MediaImage({
  media,
  className,
  imageProps = {},
}: MediaImageProps) {
  return (
    <img
      {...imageProps}
      key={media.id}
      className={classNames("media-image", className)}
      src={media.url || ""}
      title={media.title || ""}
      alt={media.title || ""}
      loading="lazy"
    />
  );
}
